import React, {Component} from 'react';
import Jumbo from '../../components/Jumbo/Jumbo';
import {Container, Row, Col} from 'reactstrap';
import Sponsors from '../../components/Sponsors/Sponsors';
import grasrot from '../../assets/images/grasrot.png';
import vipps from '../../assets/images/vipps-hvit.png';
import ungdommer from '../../assets/images/ungdommer.jpg';

class Stotte extends Component {
    render(){
        return(
            <div id="support-us" className='support-us-page'>
                <Jumbo title='Støtt vårt arbeid' image={ungdommer} content='Ungdomssamfundet er drevet som en ikke-for-profitt organisasjon av Extra Giverglede Halden. Alt vårt arbeid gjøres mulig igjennom donasjoner og statlige tilskudd.' button="false" />
                <Container>
                    <Row>
                        <Col xs='12' md='6'>
                            <h1>Hjelp oss å hjelpe</h1>
                            <p>Ungdomssamfundet er et prosjekt i regi av den frivillige organisasjonen Extra Giverglede Halden.</p>
                            <p>Vårt arbeid er mulig takket være en rekke private og bedrifts donorer som hjelper oss å hjelpe ungdommene i Halden.</p>
                            <p>Om du ikke har mulighet til å støtte oss økonomisk setter vi også stor pris på hjelp på andre måter. Ta gjerne kontakt med oss om du øsnker å være frivillig hos oss, være med på et arrangement, eller på en eller annen måte samarbeide med oss om noe.</p>
                            <section className="vipps">
                                <h2><img src={vipps} alt="Støtt oss med en Donasjon på Vipps" /></h2>
                                <p>Du kan støtte oss ved å gi en donasjon på Vipps.</p>
                                <p><strong>Vår Vipps ID er: 76660</strong></p>
                            </section>
                        </Col>
                        <Col className='grasrotandelen' xs='12' md='6'>
                            <img src={grasrot} alt="Støtt oss igjennom Grasrotandelen hos Norsk Tipping" />
                        </Col>
                    </Row>
                </Container>
                <div className="sponsors">
                    <Container>
                        <h2>Noen av våre støttespillere</h2>
                        <Sponsors/>
                    </Container>
                </div>
            </div>
        )
    }
}

export default Stotte;


// WEBPACK FOOTER //
// ./src/containers/Stotte/Stotte.js